import RequestUtils from "utils/RequestUtils";
import RoomRes from "types/res/room/RoomRes";
import CreateRoomReq from "types/req/room/CreateRoomReq";
import UpdateRoomReq from "types/req/room/UpdateRoomReq";
import DeleteRoomReq from "types/req/room/DeleteRoomReq";

export default class RoomApi {
  private constructor() {}

  static async findAll(companyId: number): Promise<RoomRes[]> {
    return await RequestUtils.getArray(RoomRes, `/room/findAll/${companyId}`);
  }

  static async create(companyId: number, data: CreateRoomReq) {
    return await RequestUtils.post(RoomRes, `/room/create/${companyId}`, data);
  }

  static async update(
    companyId: number,
    data: UpdateRoomReq
  ): Promise<RoomRes> {
    return await RequestUtils.post(RoomRes, `/room/update/${companyId}`, data);
  }

  static async delete(companyId: number, data: DeleteRoomReq) {
    return await RequestUtils.postVoid(`/room/delete/${companyId}`, data);
  }
}
